<app-customer-name-disp
  (targetSelected)="selectTargetOrganization($event)"
></app-customer-name-disp>
<app-organization-tree-edit
  *ngIf="!loading && companyOrganizationCd"
  [companyOrganizationCd]="companyOrganizationCd"
  [selectOrganizationCd]="selectOrganizationCd"
  (jumpTreeViewPage)="jumpTreeViewPage()"
></app-organization-tree-edit>
